import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { lenisRef } from "@/lib/lenis";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";
import GetFeaturedPage from "@/pages/GetFeaturedPage";
import AdminApp from "@/admin/AdminApp";

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const isDashboardHost =
    typeof window !== "undefined" && window.location.hostname.toLowerCase().startsWith("dashboard.");

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <div className="App bg-obsidian min-h-screen">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager />
        {isDashboardHost ? (
          <Routes>
            <Route path="*" element={<AdminApp />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/read/:slug" element={<ArticlePage />} />
            <Route path="/get-featured" element={<GetFeaturedPage />} />
            <Route path="/admin/*" element={<AdminApp />} />
          </Routes>
        )}
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#1E1915", border: "1px solid #2E241E", color: "#F6F3EE" } }} />
    </div>
  );
}

export default App;
